import { Box, List, ListItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ProjectNameInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.projectName")}</Typography>;
};

export const DescriptionInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.description")}</Typography>;
};

export const IndustryInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.industry")}</Typography>;
};

export const LocationInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.location")}</Typography>;
};

export const AnonymityInfo = () => {
  const { t } = useTranslation();
  return (
    <List>
      <ListItem key={1}>
        <Typography mt={2}>
          <strong>{t("labels.known")}:</strong> {t("infoMsgs.anonymityKnown")}
        </Typography>
      </ListItem>
      <ListItem key={2}>
        <Typography>
          <strong>{t("labels.unknown")}:</strong>{" "}
          {t("infoMsgs.anonymityUnknown")}
        </Typography>
      </ListItem>
    </List>
  );
};

export const ProjectTypeInfo = () => {
  const { t } = useTranslation();
  return (
    <List>
      <ListItem key={1}>
        <Typography>
          <strong>{t("labels.complete")}:</strong>{" "}
          {t("infoMsgs.completeProject")}
        </Typography>
      </ListItem>
      <ListItem key={2}>
        <Typography>
          <strong>{t("labels.simple")}:</strong> {t("infoMsgs.simpleProject")}
        </Typography>
      </ListItem>
    </List>
  );
};

export const DeviceTypeInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.deviceType")}</Typography>;
};

export const InviteLCInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.inviteLC")}</Typography>;
};

export const SkipLCInfo = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box>
        <Typography>{t("infoMsgs.skipLCtext1")}:</Typography>
      </Box>
      <Box>
        <List>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext2")}</Typography>
          </ListItem>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext3")}</Typography>
          </ListItem>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext4")}</Typography>
          </ListItem>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext5")}</Typography>
          </ListItem>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext6")}</Typography>
          </ListItem>
          <ListItem>
            <Typography>- {t("infoMsgs.skipLCtext7")}</Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export const LCEmailInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.LCemail")}</Typography>;
};
export const ConfirmEmail = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.confirmEmail")}</Typography>;
};

export const ParticipantNumInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.participantNum")}</Typography>;
};

export const ParticipantHandInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.participantHand")}</Typography>;
};
export const ParticipantElbowCInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.participantElbowCir")}</Typography>;
};
export const Skip1Info = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.skip1")}</Typography>;
};
export const Skip2Info = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.skip2")}</Typography>;
};
export const SkipActivitiesInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.skipActivities")}</Typography>;
};

export const ProjectCodeInfo = () => {
  const { t } = useTranslation();
  return <Typography>{t("infoMsgs.projectCode")}</Typography>;
};
